import './App.css';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from './sections/navbar';
import Hero from './sections/hero';
import Services from './sections/services'
import Gallery from './sections/gallery'
import Hours from './sections/hours'
import Footer from './sections/footer'
import { initSmoothScroll } from './smoothScroll';

function App() {
  useEffect(() => {
    AOS.init({ mirror: true });
    return initSmoothScroll();
  }, []);
  return (
    <>
      <Navbar />
      <Hero />
      <Services />
      <Gallery />
      <Hours />
      <Footer />
    </>
  );
}

export default App;
